import styled from 'styled-components'

export const Grid = styled.div`
  display: flex;
`;

export const Row = styled.div`
  display: flex;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

